import { useDetailedSiteSummaryQuery } from "@src/global_functions/sites/sitesQueries";
import { Skeleton } from "@src/straps/base";
import Breadcrumbs, {
  Crumb,
} from "@src/straps/base/navigation/Breadcrumbs/Breadcrumbs";
import { generatePath, matchPath, useLocation } from "react-router-dom";

export const CERTIFICATIONS_PATHS = {
  PORTFOLIO_PAGE: "/certifications",
  SITE_PAGE: "/site/:siteId/submissions/certifications",
} as const;

export default function CertificationsBreadcrumbs() {
  const location = useLocation();

  const siteId = matchPath<Record<string, string>>(location.pathname, {
    path: CERTIFICATIONS_PATHS.SITE_PAGE,
  })?.params.siteId;

  const { data: siteData } = useDetailedSiteSummaryQuery({
    siteId: siteId,
  });

  const crumbs: Crumb[] = [
    {
      name: "Certifications",
      route: CERTIFICATIONS_PATHS.PORTFOLIO_PAGE,
      childRoutes: siteId
        ? [
            {
              name: siteData ? (
                siteData.name
              ) : (
                <Skeleton className="h-full w-32" />
              ),
              route: generatePath(CERTIFICATIONS_PATHS.SITE_PAGE, { siteId }),
            },
          ]
        : undefined,
    },
  ];

  return (
    <div className="mb-5 w-full border-b border-straps-accent-3 pb-3">
      <Breadcrumbs crumbs={crumbs} />
    </div>
  );
}
